import { render, staticRenderFns } from "./Ambil.vue?vue&type=template&id=28a2c876"
import script from "./Ambil.vue?vue&type=script&lang=js"
export * from "./Ambil.vue?vue&type=script&lang=js"
import style0 from "./Ambil.vue?vue&type=style&index=0&id=28a2c876&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports